import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Password from '@/components/Password'
import Home from '@/components/Home'
import Ranking from '@/components/Ranking'
import Score from '@/components/Score'
import History from '@/components/History'
import Atrasados from '@/components/Atrasados'
import Abertos from '@/components/Abertos'
import Proximos from '@/components/Proximos'
import Checklist from '@/components/Checklist'
import Check from '@/components/Check'
import Store from '@/components/Store'
import Users from '@/components/Users'
import Checks from '@/components/Checks'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '*', redirect: '/' },
    { path: '/', name: 'login', component: Login },
    { path: '/password/:hash', name: 'password', component: Password },
    { path: '/home', name: 'home', component: Home, meta: { jwt: true }},
    { path: '/ranking', name: 'ranking', component: Ranking, props: true, meta: { jwt: true }},
    { path: '/score', name: 'score', component: Score, props: true, meta: { jwt: true }},
    { path: '/history', name: 'history', component: History, props: true, meta: { jwt: true }},
    { path: '/atrasados', name: 'atrasados', component: Atrasados, meta: { jwt: true }},
    { path: '/abertos', name: 'abertos', component: Abertos, meta: { jwt: true }},
    { path: '/proximos', name: 'proximos', component: Proximos, meta: { jwt: true }},
    { path: '/checklist', name: 'checklist', component: Checklist, meta: { jwt: true }},
    { path: '/check', name: 'check', component: Check, props: true, meta: { jwt: true }},
    { path: '/stores', name: 'stores', component: Store, meta: { jwt: true }},
    { path: '/users', name: 'users', component: Users, meta: { jwt: true }},
    { path: '/checks', name: 'checks', component: Checks, meta: { jwt: true }},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js